import {
  getAccountFaviconUrl,
  restoreAccountOrDefaultFavicon,
} from '../accountBranding';

export const showBadgeOnFavicon = () => {
  // Custom account logo: keep branding; static badge assets do not match.
  if (getAccountFaviconUrl()) return;

  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      restoreAccountOrDefaultFavicon();
    }
  });
};
